
const defaultRender = (value) => (value ? value : '--');
const columns = [
    {
        title: "User",
        dataIndex: "userDetails",
    },

    {
        title: 'Account Type',
        dataIndex: 'accountType',
        sorter: true,
    },
    {
        title: 'Account Name',
        dataIndex: 'acType',
        sorter: true,
    },
    {
        title: 'Account No.',
        dataIndex: 'login',
        sorter: true,
    },
    {
        title: 'Leverage',
        dataIndex: 'leverage',
        sorter: true,
    },
    {
        title: 'Balance',
        dataIndex: 'balance',
        sorter: true,
    },
    {
        title: 'Currency',
        dataIndex: 'currency',
        sorter: true,
    },
    {
        title: 'Domain',
        dataIndex: 'domain',
        render: defaultRender,
    },
    {
        title: 'Created Date',
        dataIndex: 'createdDate',
        sorter: true,
    },

];

export default columns;